export const getPageTitleString = (string) => {
  if (string.length > 39) {
    return `${string.slice(0, 36)}... - portal agrarlex.pl`;
  } else {
    return `${string} - portal agrarlex.pl`;
  }
};
